export default function getLinkedRegistryByRetailer(registries, retailer) {
  return (
    registries &&
    registries.find(
      // This is sort of flawed because you can link a retailer more than once, and it will always show the first one it comes across in the array.
      // But that matches the old implementation and that's what we decided to do for now.
      registry =>
        registry.retailer &&
        registry.retailer.isPartner &&
        registry.retailerId &&
        registry.retailerId === retailer.id,
    )
  );
}
